module.exports = __webpack_public_path__ + "img/total-sale.aac6323d.svg";